<template>
  <el-row class="cardData p20 su-card">
    <su-title :title="title" @discolour="discolour"/>
    <div class="cardData-list pt20" v-if="list && list.length > 0">
      <div class="flex al-cn mb20" v-for="(item,index) in list" :key="index">
        <div v-if="item.img">
          <img class="cardData-list-img" :src="item.img" alt=""/>
        </div>
        <div>
          <div class="discolour" @click="detailsClick(item)">{{ item.title }}</div>
          <div class="cardData-list-time mt10">{{ item.date }}</div>
        </div>
      </div>
    </div>
    <el-empty v-else :image-size="60"></el-empty>
  </el-row>
</template>
<script>

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    path: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  mounted() {

  },
  methods: {
    // 详情
    detailsClick(data) {
      if (!data.id) return
      let path = ''
      if (this.title === '考试通知') {
        path = '/latestNews/examNotice/details'
      } else if (this.title === '新闻资讯') {
        path = '/latestNews/newsInformation/details'
      } else if (this.title === '实习实践项目') {
        path = '/internship/overseasInternship/details'
      } else if (this.title === '实习实践动态') {
        path = '/internship/internationalChinese/details'
      } else if (this.title === '就业及升学') {
        path = '/internship/employment/details'
      }
      this.$router.push({
        path: path,
        query: {
          id: data.id,
        }
      });
    },
    // 点击更多
    discolour() {
      if (this.path) {
        this.$router.push({path: this.path})
      }
    }
  }
}
</script>
<style scoped lang="scss">
.cardData {

  &-list {

    &-img {
      width: 36px;
      height: 36px;
      background: #C32912;
      border-radius: 2px 2px 2px 2px;
    }

    &-time {
      font-size: 13px;
      color: #999999;
    }
  }
}
</style>
